import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Anchor, Card, Body } from '@sumup-oss/circuit-ui';
import Image from 'next/image';

import { StyledComponentsParams } from 'types/components';

export const ResultContainer = styled(Card)(
  ({
    theme,
    inPage,
    withXPadding,
  }: StyledComponentsParams & {
    withXPadding: boolean;
    inPage?: boolean;
  }) => css`
    align-items: flex-start;
    background-color: unset;
    border: none;
    border-radius: 0;
    box-shadow: none;
    padding: ${withXPadding ? theme.spacings.kilo : `${theme.spacings.kilo} 0`};
    ${inPage &&
    `border-bottom: ${theme.borderWidth.kilo} solid var(--cui-bg-normal-pressed);`}
  `,
);

export const ResultTitle = styled(Anchor)(
  ({ noLinks }: StyledComponentsParams & { noLinks: boolean }) => css`
    color: var(--cui-bg-strong);
    text-decoration: none;

    ${!noLinks &&
    `&:hover,
    &:visited:hover {
      color: var(--cui-bg-accent-strong);
      text-decoration: none;
    }`}
    &:visited,
    &:visited:active,
    &:active,
    &:focus {
      color: var(--cui-bg-strong);
      text-decoration: none;
    }
  `,
);

export const ResultSectionsContainer = styled('div')(
  () => css`
    display: flex;
    flex-wrap: wrap;
  `,
);

export const SectionIcon = styled(Image)(() => css``);

export const SectionLink = styled(Anchor)(
  ({ theme, noLinks }: StyledComponentsParams & { noLinks: boolean }) => css`
    display: flex;
    margin-top: ${theme.spacings.byte};
    margin-right: ${theme.spacings.mega};
    text-decoration: none;

    ${!noLinks &&
    `&:hover,
    &:visited:hover {
      text-decoration: underline;
    }`}

    & > div {
      width: unset;
    }
  `,
);

export const SectionTitle = styled(Body)(
  ({ theme }: StyledComponentsParams) => css`
    margin-left: calc(${theme.spacings.kilo} / 2);
  `,
);
